<template>
  <div>
    <h1 class="custom-left-margin content-title">{{title}}</h1>
    <div v-if="!isAuthorEmptyOrNil(author)" class="custom-left-margin">{{$t('contentHeading.sharedBy')}}
      <router-link :to="{name: 'Search', query:{searchText: undefined, key: new Date().getTime(), author:author}}">
      <span :class="{'author-share-preview': sharePreview, 'author': !sharePreview}">
        {{author}}
      </span>
      </router-link>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'content-heading',
    props: ['title', 'author', 'sharePreview'],
    methods: {
      isAuthorEmptyOrNil(author) {
        if (author === '<nil>' || !!author === false || author.trim().length === 0) {
          return true
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/colours';
  @import '../../styles/breakpoints';

  .content-title {
    font-size: 30px;
    font-weight: bold;
    color: rgba(0, 1, 2, 0.7);
    margin-bottom: 6px;
  }

  .author {
    font-size: 16px;
    font-weight: bold;
    color: $content-link-blue;
    cursor: pointer;
  }

  .author-share-preview {
    font-size: 16px;
    font-weight: bold;
  }

  .custom-left-margin {
    margin-left: 16px;
  }

  @media screen and (min-width: $breakpoint-small) {
    .custom-left-margin {
      margin-left: 24px;
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .content-title {
      font-size: 20px;
    }
    .content-author {
      font-size: 14px;
    }
  }

  @media screen and (min-width: $breakpoint-medium) {
    .custom-left-margin {
      margin-left: 0px;
    }
  }
</style>
